// extracted by mini-css-extract-plugin
export var divider = "_tr-0";